module.exports = __webpack_public_path__ + "img/fangan.43e63ede.png";